import { configureStore } from '@reduxjs/toolkit';
import apiErrorReducer from './slices/apiError.slice';
import authReducer, { authPersistenceMiddleware } from './slices/auth.slice';
import partnerReducer from './slices/partner.slice';
import basicInfoReducer from './slices/basicInfoSlice';
import personalDetailsReducer from './slices/personalDetailsSlice';
import preferenceInformationReducer from './slices/preferenceInformationSlice';
import emergencyContactReducer from './slices/emergencyContactSlice';
import availabilityReducer from './slices/availabilitySlice';
import enrollmentReducer from './slices/enrollment.slice';
import demographicReducer from './slices/demographic.slice';
import countryReducer from './slices/countrySlice';
import stateReducer from './slices/stateSlice';
import coachDemographicReducer from './slices/coachDemographicSlice';
import subscriptionReducer from './slices/subscription.slice';
import memberSubscriptionReducer from './slices/memberSubscriptionSlice';
import { dashboardApi } from '../../features/dashboard/api/dashboard.api';
import { billingApi } from '../../features/billing/api/billing.api';

export const store = configureStore({
  reducer: {
    apiError: apiErrorReducer,
    auth: authReducer,
    partner: partnerReducer,
    basicInfo: basicInfoReducer,
    personalDetails: personalDetailsReducer,
    preferenceInformation: preferenceInformationReducer,
    emergencyContact: emergencyContactReducer,
    availability: availabilityReducer,
    enrollment: enrollmentReducer,
    demographic: demographicReducer,
    country: countryReducer,
    state: stateReducer,
    coachDemographics: coachDemographicReducer,
    subscription: subscriptionReducer,
    memberSubscription: memberSubscriptionReducer,
    [dashboardApi.reducerPath]: dashboardApi.reducer,
    [billingApi.reducerPath]: billingApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        warnAfter: 500,
        ignoredPaths: ['auth.tokenExpiresAt'],
      },
      immutableCheck: {
        warnAfter: 500,
      },
    })
      .prepend(authPersistenceMiddleware)
      .concat(dashboardApi.middleware)
      .concat(billingApi.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
